import { $getRoot, type EditorState } from "lexical";
import { useCallback } from "react";
import { $isSurveyLinkNode } from "../nodes/survey-link-node";
import { urlRegex } from "./link-matchers";

export const TRACKING_LINK_LENGTH = 55;
// Survey links are shortened to `https://ce-l.ink/{7-char id}` (17 + 7 = 24) when sent.
export const SHORTENED_SURVEY_LINK_LENGTH = 24;
export const MEDIAN_MERGE_TAG_LENGTH = 9;

export const getCharacterCount = (state: EditorState): number => {
  return state.read(() => {
    const root = $getRoot();
    const textNodes = root.getAllTextNodes();

    if (!textNodes || textNodes.length === 0) return 0;

    const count = textNodes.reduce((prev, curr) => {
      if (curr.__type === "merge-tag-v2") {
        return prev + MEDIAN_MERGE_TAG_LENGTH;
      }

      // A survey link's visible child is the literal text "survey_link", but it is
      // shortened when sent, so count its shortened length rather than the label.
      if ($isSurveyLinkNode(curr.getParent())) {
        return prev + SHORTENED_SURVEY_LINK_LENGTH;
      }

      let text = curr.__text;
      text = text.replace(urlRegex, () => "_".repeat(TRACKING_LINK_LENGTH));

      return prev + text.length;
    }, 0);

    const lineBreaks = textNodes.filter((x) => x.__type !== "merge-tag-v2").length;
    return count + (lineBreaks > 0 ? lineBreaks - 1 : 0);
  });
};

export const useGetCharacterCount = (): ((state: EditorState) => number) => {
  return useCallback((state: EditorState) => getCharacterCount(state), []);
};
